(() => {
  const alreadyPrefetchedUrls = new Set();

  window.swinger.observer.initialize(':not(nav) > a[href$=".jpg"][rel~="prefetch"],nav > a[href$=".jpg"][rel~="prefetch"]:first-child', (elem) => {
    const url = elem.getAttribute('href');

    if (!url || alreadyPrefetchedUrls.has(url)) {
      return;
    }

    alreadyPrefetchedUrls.add(url);

    window.requestIdleCallback(() => {
      console.log(`Preloading image ${url}`);
      const img = new Image();
      img.fetchPriority = 'low';
      img.src = url;
    }, {
      timeout: 1000,
    });
  });

  if (window.swinger.config.isClickDummy) {
    return;
  }

  if (
    HTMLScriptElement.supports
    && HTMLScriptElement.supports('speculationrules')
  ) {
    return;
  }

  window.swinger.observer.initialize('a[href][rel~="prefetch"]:not([href^="http"])', (elem) => {
    const url = elem.getAttribute('href');

    if (!url || alreadyPrefetchedUrls.has(url)) {
      return;
    }

    alreadyPrefetchedUrls.add(url);

    window.requestIdleCallback(() => {
      ['prefetch', 'prerender'].forEach((rel) => {
        const link = document.createElement('link');
        link.setAttribute('rel', rel);
        link.setAttribute('href', url);

        document.head.appendChild(link);
      });
    }, {
      timeout: 3000,
    });
  });
})();
